var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0H7C6.4 0 6 0.4 6 1V15C6 15.6 6.4 16 7 16H9C9.6 16 10 15.6 10 15V1C10 0.4 9.6 0 9 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10H1C0.4 10 0 10.4 0 11V15C0 15.6 0.4 16 1 16H3C3.6 16 4 15.6 4 15V11C4 10.4 3.6 10 3 10Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5H13C12.4 5 12 5.4 12 6V15C12 15.6 12.4 16 13 16H15C15.6 16 16 15.6 16 15V6C16 5.4 15.6 5 15 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatement);
export default __webpack_public_path__ + "static/media/statement.c4f9dd324b3b8d43ba20541d2c2a0c25.svg";
export { ForwardRef as ReactComponent };